import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Progress } from 'antd';
import AbacusView from '../../base/abacus';
import Result from '../../base/result';
import Help from '../../base/help';
import DragComp from './DragComp';
import { generateRandomNumberSeries } from '../../../utils';
import './index.less';
import { t } from '../../../languages';
import ExerciseBlocker from '../../Utils/ExerciseBlocker';
import ChangeOrientation from '../../Utils/ChangeOrientation';
import moment from 'moment';
import BackMusic from '../../base/BackMusic';
import { getRandomMessage2 } from '../utils';

const QuantityGame = (props) => {
    const [state, setState] = useState({
        eid: 0,
        series: [],
        current: 0,
        results: [],
        times: [],
        numberinbox: 0,
        message: null,
        message2: null,
        showresults: false,
        moved: 0,
        help: false,
    });
    const [initMoment, setInitMoment] = useState(0);

    useEffect(() => {
        setInitMoment(moment());
        handleRepeat();
    }, []);

    const handleRate = () => {
        const { current, series, results } = state;
        const currentNumber = series[current];
        const current_result = currentNumber === state.numberinbox ? 1 : 0;

        const message = current_result
            ? t(props.lang, 'rightanswer')
            : `${t(props.lang, 'wronganswer')} ${currentNumber}`;
        const message2 = current_result
            ? t(props.lang, getRandomMessage2('great'))
            : t(props.lang, getRandomMessage2('nodiscorage'));

        setState((prevState) => ({
            ...prevState,
            results: [...results, current_result],
            message,
            message2,
        }));
    };

    const handleNext = () => {
        const { current, series, results } = state;

        if (current < series.length - 1) {
            setState((prevState) => ({
                ...prevState,
                current: current + 1,
                numberinbox: 0,
                message: null,
                message2: null,
                moved: 0,
            }));
        } else {
            const num = props.params.num;
            const hits = results.reduce((acc, aR) => acc + aR, 0);
            const errors = num - hits;
            const passed = errors > props.params.errors ? 0 : 1;
            const uid = props.uid;
            const eid = props.eid;
            const is_test = props.params.is_test ? props.params.is_test : false;
            const coins = props.params.coins;
            const elapsedTime = moment().diff(initMoment, 'seconds');

            props.saveResult(uid, `${uid}-${eid}`, { id: 'QG', uid, eid, p: passed, h: hits, e: errors, c: passed ? coins : 0, r: results, s: series, et: elapsedTime, });

            if (!is_test) {
                setState((prevState) => ({
                    ...prevState,
                    showresults: true,
                }));
            }
        }
    };

    const handleRepeat = () => {
        const params = props.params;
        const series =
            params
                ? generateRandomNumberSeries(params.num, params.init, params.finish, null)
                : generateRandomNumberSeries(9, 1, 9, null);

        setState({
            series,
            current: 0,
            numberinbox: 0,
            results: [],
            message: null,
            message2: null,
            showresults: false,
            moved: 0,
            help: false,
        });
    };

    const handleMove = (items, box) => {
        const number = items.reduce((acc, item) => acc + item.value, 0);
        if (box === 'dest') {
            setState((prevState) => ({
                ...prevState,
                numberinbox: number,
                moved: 1,
            }));
        } else {
            setState((prevState) => ({
                ...prevState,
                numberinbox: 9 - number,
                moved: 1,
            }));
        }
    };

    const handleHelp = () => {
        setState((prevState) => ({
            ...prevState,
            help: false,
        }));
    };

    const showHelp = () => {
        setState((prevState) => ({
            ...prevState,
            help: !prevState.help,
        }));
    };

    const {
        series,
        current,
        results,
        numberinbox,
        message,
        message2,
        showresults,
        help,
        moved,
    } = state;

    const currentNumber = series[current];
    const rate = results[current];
    const messagestyle = message ? (!rate ? ' error' : ' valid') : '';
    const percent = Math.round((current / props.params.num) * 100);

    const is_test = props.params.is_test ? props.params.is_test : false;
    const stillrows = Array.from(Array(props.params.rows).keys());

    const params = {
        ...props.params,
        rows: props.params ? props.params.rows : 1,
        number: currentNumber,
        stillrows,
    };

    if (!showresults) {
        return (
            <Row className="exercise">
                <BackMusic source={'random'} />

                <ChangeOrientation to={'portrait'} />

                {!is_test && (
                    <Col span={21} className="progress-bar">
                        <Progress percent={percent} showInfo={false} />
                    </Col>
                )}

                <Col span={24} className="exercise-body">
                    <ExerciseBlocker show={messagestyle} />
                    {help && (
                        <Help handleHelp={handleHelp}>
                            <img alt="help" src="./static/help/quantity_objs.png" />
                        </Help>
                    )}

                    <section className="quantitygame">
                        <article className="animated bounceIn" key={currentNumber}>
                            <AbacusView
                                params={params}
                                isactive={false}
                                hidelatframe={true}
                                hideheaderlabels={true}
                            />
                        </article>
                        <article className="dragobjects">
                            <DragComp
                                onMove={handleMove}
                                current={current}
                                type={params.subtype}
                            />
                        </article>
                    </section>
                </Col>

                <Col span={24}>
                    <Row className={`botones${messagestyle}`}>
                        <Col span={24} className="message">
                            {message}
                        </Col>

                        {!message && (
                            <Col span={24}>
                                <Button
                                    key="submit"
                                    type="primary"
                                    onClick={handleRate}
                                    style={{ width: '90%' }}
                                    disabled={!moved}
                                >
                                    {t(props.lang, 'grade')}
                                </Button>
                            </Col>
                        )}

                        {message && (
                            <Col span={24}>
                                <Button
                                    key="submit"
                                    type="primary"
                                    onClick={handleNext}
                                    style={{ width: '90%' }}
                                >
                                    {t(props.lang, 'next')}
                                </Button>
                            </Col>
                        )}

                        {message2 && (
                            <Col span={24} className="message">
                                {message2}
                            </Col>
                        )}
                    </Row>
                </Col>
            </Row>
        );
    } else {
        return (
            <Result
                params={props.params}
                results={results}
                handleRepeat={handleRepeat}
                handleCancel={props.handleCancel}
                lang={props.lang}
            />
        );
    }
};

export default QuantityGame;